import script from "./PbxDeviceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxDeviceDetail.vue?vue&type=script&setup=true&lang=js"

import "./PbxDeviceDetail.vue?vue&type=style&index=0&id=4a6e5d09&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a6e5d09"]])

export default __exports__